export default __webpack_public_path__ + "static/media/alert-triangle-red.a279b17e.svg";